import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 請款 create／update body：禁送 payeeId／totalAmount／requestNo／status。
 * 保留 paymentReason、roundingMode、remark、lines、voucherIds、updatedAt 等。
 */
export function toPaymentRequestWriteBody(payload = {}) {
  const {
    payeeId: _payeeId,
    totalAmount: _totalAmount,
    requestNo: _requestNo,
    status: _status,
    id: _id,
    ...rest
  } = payload ?? {};

  return keysToSnake(rest);
}
